// extracted by mini-css-extract-plugin
export default {"FreightCalculationManagement":"FreightCalculationManagementPage_FreightCalculationManagement__+L6VC"};